import React from 'react';
import { globalDi } from './global';
export const Context = /*#__PURE__*/React.createContext({
  getDependencies: globalDi.getDependencies
});